import React, { memo, useCallback, useEffect, useState } from "react"

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip,
} from "reactstrap"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Select from "react-select"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getCeremonies } from "../../../store/ceremony/actions"
import {
  addNewVendor_pricing,
  getVendor_pricing,
  updateVendor_pricing,
} from "../../../store/vendor_pricing/actions"
import {
  getUnitOfMeasure,
  getVendor_catsByvendorId,
} from "../../../helpers/backend_helper"
import { showPopup } from "../../../store/popup/actions"
import imageBaseUrl from "../../../helpers/imageBaseUrl"
import Dropzone from "react-dropzone"
import Pdf_Icon from '../../../assets/images/PDF_file_icon.png'

const AddPricingVendor = props => {
  const location = useLocation()
  const history = useHistory()
  const params = useParams()
  const dispatch = useDispatch()
  const [name, setName] = useState(props?.vendor?.name ?? "")
  const [value, setValue] = useState(props?.vendor?.value ?? "")
  const [maxValue, setMaxValue] = useState(props?.vendor?.maxValue ?? "")
  const [unit, setUnit] = useState(props?.vendor?.unit ?? "")
  const [unitOfMajor, setUnitOfMajor] = useState(
    props?.vendor?.unitOfMajor ?? ""
  )
  const [isActive, setIsActive] = useState(true)
  const [ceremony, setCeremony] = useState([])
  const [laoding, setLoading] = useState(false)
  const [vendor_type, setVendor_type] = useState([])
  const [types, setTypes] = useState([])
  const [unitOfMeasure, setUnitOfMeasure] = useState([])
  const [unitOfMeasureSelected, setUnitOfMeasureSelected] = useState({})
  const [typeSelected, setTypeSelected] = useState([])
  const [haveMax, setHaveMax] = useState(false)
  const [selectedFiles, setselectedFiles] = useState([])
  const [file, setFile] = useState("")
  const [modal, setModal] = useState(false)

  const ceremonies = useSelector(state => state.ceremony.ceremonies.ceremonies)
  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )

    setselectedFiles(files)
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  const cancelEditing = () => {
    props.setToggle(false)
    setName("")
    setUnit("")
    setUnitOfMajor("")
    setValue("")
    setMaxValue("")
    setIsActive(true)
    setFile("")
    setselectedFiles([])
  }

  useEffect(() => {
    if (props?.vendor?.id) {
      props.setToggle(true)
    }

    setName(props?.vendor?.name ?? "")
    setValue(props?.vendor?.value ?? "")
    setMaxValue(props?.vendor?.max_value ?? "")
    setUnit(props?.vendor?.unit ?? "")
    setUnitOfMajor(props?.vendor?.unit_of_major ?? "")
    setIsActive(props?.vendor?.is_active == 1 ? true : false)
    setHaveMax(props?.vendor?.is_range == 1 ? true : false)

    props?.vendor.image ? setselectedFiles([
      {
        preview: imageBaseUrl + props.vendor.image,
        name:props.vendor.image
      },
    ]) : setselectedFiles([])
  }, [props?.vendor])

  useEffect(() => {
    props.toggle
      ? props?.vendor?.ceremony_id
        ? setCeremony({
            label: props?.vendor?.ceremony_name,
            value: props?.vendor?.ceremony_id,
          })
        : setCeremony({ label: "All events", value: 0 })
      : setCeremony({
          label: "Wedding",
          value: ceremonies.find(c => c?.name_en?.toLowerCase() == "wedding")
            ?.id,
        })
    props.toggle
      ? setTypeSelected({
          label: props?.vendor?.vendor_cat_name,
          value: props?.vendor?.vendor_type_id,
        })
      : setTypeSelected({ label: types[0]?.label, value: types[0]?.value })
    props.toggle
      ? setUnitOfMeasureSelected(
          unitOfMeasure.filter(
            u => u.value == props?.vendor?.unit_of_measure_id
          )
        )
      : setUnitOfMeasureSelected({
          label: unitOfMeasure[0]?.label,
          value: unitOfMeasure[0]?.value,
        })
        
   
  }, [props.toggle, types, ceremonies, props.vendor])
  useEffect(() => {
    const getType = async () => {
      let response = await getVendor_catsByvendorId({
        vendor_id: params.vendor_id,
      })
      if (response.success) {
        setTypes(
          response.data.map(r => ({
            label: r.cat_name_en,
            value: r.vendor_category_id,
          }))
        )
      }
    }
    const getUnitOfMeasuree = async () => {
      let response = await getUnitOfMeasure()

      if (response.success) {
        setUnitOfMeasure(
          response.data.map(r => ({ label: r.name, value: r.id }))
        )
      }
    }
    getUnitOfMeasuree()
    getType()
    dispatch(getCeremonies({ is_active: 1 }))
  }, [dispatch])

  const addNewPrice = () => {
    //  if(ceremony.value){
    //       dispatch(showPopup({title:'Please select a aceremony type',warning:true}))
    //     }else{

    let data = {
      vendor_id: params.vendor_id,
      name: name,
      // vendor_type_id: typeSelected.value,
      ceremony_id: ceremony.value,
      unit: unit,
      unit_of_major: unitOfMajor,
      unit_of_measure_id: unitOfMeasureSelected.value,
      value: value,
      max_value: maxValue,
      is_active: 1,
      is_range: haveMax ? "1" : "0",
      is_allevents: ceremony.value == "0" ? 1 : 0,
    }

    // return;
    if (props.toggle) {
      data.id = props?.vendor?.id
      if (!selectedFiles[0]) {
        data.remove_image = 1
      } else if (selectedFiles[0].size) {
        data.image = selectedFiles[0]
      }
      setLoading(true)
      dispatch(updateVendor_pricing(data, history))
      setLoading(false)
      dispatch(
        getVendor_pricing({
          id: params.vendor_id,
          offset: props.offset,
          page_size: props.page_size,
        })
      )
    } else {
      if (selectedFiles[0]?.size) {
        data.image = selectedFiles[0]
      }
      setLoading(true)
      dispatch(addNewVendor_pricing(data, history))
      cancelEditing()
      dispatch(
        getVendor_pricing({
          id: params.vendor_id,
          offset: props.offset,
          page_size: props.page_size,
        })
      )
      setLoading(false)
    
    }
    // }
  }
  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }, [modal])

  const ceremoniesOptions = ceremonies?.map(v => {
    return { label: v.name_en, value: v.id }
  })
  // const vendorTypesOptions = ty.map(v => {
  //   return { label: v.cat_name_en, value: v.id }
  // }) || []
  console.log({selectedFiles})
  return (
    <React.Fragment>
      <td>
        <div className="mb-3">
          {!selectedFiles[0] ||
          (selectedFiles[0]?.preview &&
            selectedFiles[0]?.preview.split("/").pop() == 'null') || !selectedFiles[0] ? (
            <div
              onClick={() => setModal(true)}
              className="avatar-lg d-inline-block me-2"
            >
              <div className="avatar-title bg-soft-primary rounded-circle text-primary">
                <i className="mdi mdi-account-circle m-0"></i>
              </div>
            </div>
          ) : selectedFiles[0]?.preview.split(".").pop() == "pdf" || selectedFiles[0]?.name.split(".").pop() == "pdf" ? (
            <>
              <img
                onClick={() => setModal(true)}
                className="avatar-lg rounded-circle me-2"
                src={Pdf_Icon}
                alt=""
              />
            </>
          ):   <>
          <img
            onClick={() => setModal(true)}
            className="avatar-lg rounded-circle me-2"
            src={selectedFiles[0].preview}
            alt=""
          />
        </>}
        </div>
      </td>
      <td>
        <div className="mb-3">
          <Input
            name="name"
            
            placeholder="Name"
            type="textarea"
            style={{height:100}}
            onChange={e => setName(e.target.value)}
            value={name}
          />
        </div>
      </td>

      {/* <td>
        <div className="">

          <Select
            value={typeSelected}
            onChange={option => {
              setTypeSelected(option)
            }}
            options={types}
            classNamePrefix="select2-selection"
          />
        </div>
      </td> */}
      <td>
        <div className="">
          <Select
            value={ceremony}
            onChange={option => {
              setCeremony(option)
            }}
            options={[{ label: "All events", value: 0 }, ...ceremoniesOptions]}
            classNamePrefix="select2-selection"
          />
        </div>
      </td>
      {/* <td>
        <div>

          <Input
            name="unit"
            placeholder="Unit"
            type="number"
            onChange={(e)=>setUnit(e.target.value)}
            value={unit}
          />

        </div>
      </td> */}
      <td>
        <div className="mb-3">
          {/* <Input
  name="uit_of_major"
  placeholder="unit of measure"
  type="text"
  onChange={(e)=>setUnitOfMajor(e.target.value)}
  value={unitOfMajor}
  disabled
/> */}
        </div>
      </td>
      <td>
        <div className="mb-3">
          <Select
            value={unitOfMeasureSelected}
            onChange={option => {
              setUnitOfMeasureSelected(option)
            }}
            options={unitOfMeasure}
            classNamePrefix="select2-selection"
          />
        </div>
      </td>
      <td>
        <div className="mb-3">
          <Input
            name="value"
            placeholder={haveMax ? "Min price" : "Price"}
            type="text"
            onChange={e => setValue(e.target.value)}
            value={value}
          />
        </div>
      </td>
      <td>
        <div className="mb-3 form-check form-switch form-switch-lg center">
          <input
            onClick={e => {
              setHaveMax(!haveMax)
              props.setHaveMax(!haveMax)
            }}
            type="checkbox"
            className="form-check-input"
            id="customSwitchsizelg"
            // defaultChecked={haveMax}
            checked={haveMax}
          />
        </div>
      </td>
      <td>
        <div className="mb-3">
          <Input
            disabled={!haveMax}
            name="max_value"
            placeholder="Max price"
            type="text"
            onChange={e => setMaxValue(e.target.value)}
            value={maxValue}
          />
        </div>
      </td>
      <td>
        <div className="form-check form-switch form-switch-lg">
          {/* {
            isActive ? 
            <input
            type="checkbox"
            className="form-check-input"
            id="customSwitchsizelg"
            defaultChecked={true}
            // checked={isActive}
            onClick={(a)=>setIsActive(false)}
          /> : 

          <input
          type="checkbox"
          className="form-check-input"
          id="customSwitchsizelg"
          defaultChecked={false}
          // checked={isActive}
          onClick={(a)=>setIsActive(true)}
        />
          } */}
        </div>
      </td>
      <td>
        <div className="mb-3">
          {laoding ? (
            <Spinner type="grow" color="primary" />
          ) : (
            <Button onClick={() => addNewPrice()} color="primary" className="">
              {props?.vendor?.id ? "Save" : "Submit"}
            </Button>
          )}
          {props.toggle && (
            <Button onClick={cancelEditing} color="primary" className="">
              Cancel
            </Button>
          )}
        </div>
      </td>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {"Uploads Images"}
        </ModalHeader>
        <ModalBody>
          <Dropzone
            onDrop={acceptedFiles => {
              handleAcceptedFiles(acceptedFiles)
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <div className="dropzone">
                <div className="dz-message needsclick" {...getRootProps()}>
                  <input {...getInputProps()} />
                  <div className="mb-3">
                    <i className="display-4 text-muted uil uil-cloud-upload" />
                  </div>
                  <h4>Drop files here or click to upload.</h4>
                </div>
              </div>
            )}
          </Dropzone>
          <div className="dropzone-previews mt-3" id="file-previews">
            {selectedFiles.map((f, i) => {
              console.log(f)
              return (
                <Card
                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                  key={i + "-file"}
                >
                  <div
                    className="p-2"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Row className="align-items-center">
                      <Col className="col-auto">
                        {f?.name?.split('.').pop() == 'pdf' ? 
                         <img
                         data-dz-thumbnail=""
                         height="80"
                         className="avatar-sm rounded bg-light"
                         alt={f.name}
                         src={Pdf_Icon}
                       />
                        :
                        <img
                          data-dz-thumbnail=""
                          height="80"
                          className="avatar-sm rounded bg-light"
                          alt={f.name}
                          src={f.preview}
                        />

                      }
                      </Col>
                      <Col>
                        <Label to="#" className="text-muted font-weight-bold">
                          {f.name}
                        </Label>
                        <p className="mb-0">
                          <strong>{f.formattedSize}</strong>
                        </p>
                      </Col>
                    </Row>
                    <div
                      className="align-self-center"
                      onClick={() => {
                        setselectedFiles([])
                      }}
                    >
                      <i
                        className="uil uil-trash-alt font-size-24 text-danger"
                        id="deletetooltip"
                      />
                      <UncontrolledTooltip
                        placement="top"
                        target="deletetooltip"
                      >
                        Delete
                      </UncontrolledTooltip>
                    </div>
                  </div>
                </Card>
              )
            })}
          </div>
          <Row>
            <Col>
              <div className="text-end mt-3">
                <button
                  type="button"
                  className="btn btn-success save-user"
                  onClick={() => setModal(false)}
                >
                  Save
                </button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default AddPricingVendor
